import 'url-polyfill';
import VueResource from 'vue-resource';
import Vue from 'vue';
import Cookies from 'js-cookie';
import MobileDetect from '../core/mobile-detect';

Vue.use(VueResource);
Vue.use(MobileDetect);

const urlPrefix = `${window.location.origin}${window.SITE_URL}`;

function getAgentReport(params, headers) {
  const url = new URL(
    'api/user_behaviour/agent_report',
    urlPrefix,
  );

  return Vue.http.post(url.href, params, { headers }).then();
}

function saveUserConversion(data, headers) {
  const url = new URL(
    'api/user_conversion/save',
    urlPrefix,
  );

  Vue.http.post(url.href, data, { headers }).then();
}

export default {
  sendReport(ics, stockId, method, type, agent) {
    const data = {
      id: Cookies.get('id'),
      ics_type: ics,
      emp_id: agent.emp_id,
      stockId,
      stockUrl: window.location.href,
      method, // 'Email','Mobile','Whatsapp','WeChat','DeptTel'
      fromType: type, // openday, agent, stock
    };

    getAgentReport({
      ...data,
    }, {
      csrftoken: window.csrf_token,
    })
      .then(() => {});
  },

  userConversion(method, stockId, agent) {
    const data = {
      method, // 'Email','Mobile','Whatsapp','WeChat','DeptTel'
      stockUrl: window.location.href,
      empId: agent.emp_id,
    };
    let userAgent = 'Desktop';
    if (Vue.prototype.$md.mobile() && !Vue.prototype.$md.tablet()) {
      userAgent = 'Mobile';
    } else if (Vue.prototype.$md.tablet()) {
      userAgent = 'Tablet';
    }

    const record = {
      ...data,
      userAgent,
      stockId,
    };
    saveUserConversion({
      ...record,
    }, {
      csrftoken: window.csrf_token,
    });
  },
};
